import { useEffect } from "react";

import { useGetPartnerPrograms } from "@/partner/usePartnerConfig";

import { useCustomerProgram } from "./useCustomerProgram";

export const useAutoSelectSurvey = () => {
    const { customerProgram, setCustomerProgram, removeCustomerProgram } = useCustomerProgram();
    const programs = useGetPartnerPrograms();

    useEffect(() => {
        if (programs?.length === 1) {
            setCustomerProgram(programs[0]);
        } else {
            removeCustomerProgram();
        }
    }, [programs, setCustomerProgram, removeCustomerProgram]);

    return { customerProgram };
};
